import { useMediaQuery } from "@material-ui/core";
import React, { Fragment } from "react";
import styled from "styled-components";

const MobileTableContainer = styled.div`
  max-width: 100vw;
  overflow: scroll;
  width: 100%;
`;

const DesktopTableContainer = styled.div`
  width: 100%;
`;

interface ResponsiveTableProps {
  children: JSX.Element | JSX.Element[];
}
export default function ResponsiveTable({
  children,
}: ResponsiveTableProps): JSX.Element {
  const isDesktop = useMediaQuery("(min-width:480px)");
  if (!isDesktop) {
    return <MobileTableContainer>{children}</MobileTableContainer>;
  } else {
    return <DesktopTableContainer>{children}</DesktopTableContainer>;
  }
}
